<template lang="html">
  <div id="blog-page">
    <section class="blog-list-section pt-5 pb-5 bg-light">
      <div class="container">
        <!-- Header -->
        <div class="text-center mb-4">
          <h1 class="blog-list-title mb-3">Blog EcoMéxico</h1>
          <p class="blog-list-subtitle text-secondary mx-auto">
            Noticias, tendencias y tutoriales sobre tecnología de medición, drones y topografía
          </p>
        </div>

        <!-- Category Filters -->
        <!-- <div class="mb-4">
          <div class="d-flex flex-wrap justify-content-center">
            <button
              v-for="cat in categories"
              :key="cat"
              type="button"
              class="btn btn-sm mr-2 mb-2"
              :class="selectedCategory === cat ? 'btn-danger' : 'btn-outline-danger'"
              @click="selectedCategory = cat"
            >
              {{ cat }}
            </button>
          </div>
        </div> -->

        <loading-component-s1 v-if="isLoading"></loading-component-s1>

        <!-- Featured Posts -->
        <div v-if="notedBlogs.length > 0" class="mb-5">
          <h2 class="h4 font-weight-bold text-dark">Destacados</h2>

          <div class="row">
            <div class="col-12 px-0">
              <swiper class="swiper mb-4" :options="articlesOptions">
                <swiper-slide v-for="(post, pnInx) in notedBlogs" :key="'pnInx-'+pnInx">
                  <div class="col-12 px-0 col-article-card-s1">
                    <router-link :to="'/blog/' + $root._converToURL(post.title, post.id)" class="text-decoration-none text-body">
                      <div class="card border-0 shadow h-100 blog-card">
                        <div class="position-relative overflow-hidden rounded-top">
                          <img
                            v-bind:style="{ backgroundImage: 'url('+( post.image || 'public/images/shared/placeholder.svg' )+')' }"
                            src="public/images/pages/blog/blog.png"
                            :alt="post.title"
                            class="card-img-top placed-backg blog-card-img featured-img"
                          />
                          <!-- <span class="badge badge-danger position-absolute m-3">{{ post.category }}</span> -->
                        </div>
                        <div class="card-body">
                          <h3 class="t-150 card-title font-weight-bold blog-card-title">{{ post.title }}</h3>
                          <p class="card-text text-secondary mb-3 line-clamp-2">{{ post.short_description }}</p>
                          <div class="d-flex flex-wrap align-items-center small text-muted mb-2">
                            <span class="mr-3">
                              <i class="fa-solid fa-user mr-1"></i>{{ post.author }}
                            </span>
                            <span class="mr-3">
                              <i class="fa-solid fa-calendar-alt mr-1"></i>{{ post.date }}
                            </span>
                          </div>
                          <!-- <span class="text-danger font-weight-bold">{{ post.readTime }}</span> -->
                        </div>
                      </div>
                    </router-link>
                  </div>
                </swiper-slide>
                
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
            </div>
          </div>

          

          <div class="row">
            
          </div>
        </div>

        <!-- Regular Posts -->
        <div v-if="blogs.length > 0">
          <h2 class="h4 font-weight-bold text-dark mb-4">Todos los Artículos</h2>
          <div class="row">
            <div
              v-for="(post, pInx) in blogs"
              :key="'pInx-'+pInx"
              class="col-12 col-md-6 col-lg-4 mb-4 col-article-card-s1"
            >
              <router-link :to="'/blog/' + $root._converToURL(post.title, post.id)" class="text-decoration-none text-body">
                <div class="card border-0 shadow h-100 blog-card">
                  <div class="position-relative overflow-hidden rounded-top">
                    <img
                      :src="post.image || 'public/images/shared/placeholder.svg'"
                      :alt="post.title"
                      class="card-img-top placed-backg blog-card-img regular-img"
                    />
                    <!-- <span class="badge badge-danger position-absolute m-3">{{ post.category }}</span> -->
                  </div>
                  <div class="card-body">
                    <h3 class="t-150 card-title font-weight-bold blog-card-title small">{{ post.title }}</h3>
                    <p class="card-text text-secondary small mb-3 line-clamp-2">{{ post.short_description }}</p>
                    <div class="d-flex justify-content-between align-items-center small text-muted mb-2">
                      <span><i class="fa-solid fa-calendar-alt mr-1"></i>{{ post.date }}</span>
                      <!-- <span class="text-danger font-weight-bold">{{ post.readTime }}</span> -->
                    </div>
                    <span class="text-danger font-weight-bold small">
                      Leer más <i class="fa-solid fa-arrow-right ml-1"></i>
                    </span>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <!-- No Results -->
        <div v-if="blogs.length === 0" class="text-center py-5">
          <p class="text-muted">No se encontraron artículos en esta categoría.</p>
        </div>

        <!-- Newsletter CTA -->
        <div class="mt-5 rounded p-4 p-md-5 text-center text-white blog-newsletter-cta">
          <h3 class="h4 font-weight-bold mb-3">Suscríbete a Nuestro Newsletter</h3>
          <p class="mb-4 opacity-90">
            Recibe las últimas noticias, tutoriales y ofertas exclusivas directamente en tu correo
          </p>
          <div class="row justify-content-center">
            <div class="col-12 col-md-8 col-lg-6">
              <div class="input-group">
                <input
                  v-model="newsletterEmail"
                  type="email"
                  class="form-control"
                  placeholder="Tu correo electrónico"
                />
                <div class="input-group-append">
                  <button type="button" class="btn btn-light text-danger font-weight-bold" @click="onSubscribe">
                    Suscribirse
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: true,
      notedBlogs: [],
      blogs: [],

      selectedCategory: 'Todos',
      newsletterEmail: '',
      // categories: [
      //   'Todos',
      //   'Drones',
      // ],

      // == Carousel options ==
      articlesOptions: {
        slidesPerView: 2,
        spaceBetween: 10,
        loop: true,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1200: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 0
          },
        }
      }
      // == ==
    }
  },

  methods: {
    getBlogs() {
      this.isLoading = true;
      axios.get(tools.url('/api/blogs')).then((response) => {
        this.blogs = response.data.blogs;
        this.notedBlogs = response.data.noted_blogs;
        if(this.notedBlogs.length == 1) {
          this.articlesOptions.loop = false;
        }
        this.isLoading = false;
      }).catch((error) => {
        console.log(error);
      });
    },

    onSubscribe() {
      // Aquí puedes conectar con tu API de newsletter
      if (!this.newsletterEmail) return
      console.log('Subscribe:', this.newsletterEmail)
      this.newsletterEmail = ''
    },
  },

  mounted() {
    this.getBlogs();
  },
}
</script>
